// extracted by mini-css-extract-plugin
export default {"modalContent":"AddOrderModal_modalContent__TsDsY"};